import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { apiRequest } from "services/ServiceUtil";
import { LIBRARY_SERVICE_METHOD } from "services/commonService";
import { LibraryHallState } from "./Hall";

const SLICE = "FunctionalAreas";

const initialState: LibraryHallState = {
  list: []
};

export const fetchFunctionalAreaAsync = createAsyncThunk(
  `${SLICE}/fetchFunctionalAreaAsync`,
  async (data: {}, thunkApi) => apiRequest(LIBRARY_SERVICE_METHOD.getFunctionalAreas, {}, thunkApi, [])
);

export const FunctionalAreaSlice = createSlice({
  name: SLICE,
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(fetchFunctionalAreaAsync.fulfilled, (state, action: any) => {
      state.list = action.payload?.functionalAreas;
    });
  }
});

export default FunctionalAreaSlice.reducer;
